"use strict";
function pagination(){
    document.querySelectorAll(".load-more").forEach((btn) => {
      btn.classList.remove('loading');
      var url = btn.getAttribute('href');
      if (btn.classList.contains("infinite")){
        var observer = new IntersectionObserver(
          function(entries){
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1){
                loadMoreproducts(url);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(btn);
      } else {
        btn.addEventListener("click",(e) => {
            e.preventDefault();
            btn.classList.add('loading');
            loadMoreproducts(url);
          },
          false
        );
      }
    });
}
pagination();
window.OBStockFirst?.init();
function loadMoreproducts(url){
    fetch(url).then((response) => response.text()).then(async (responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      await window.OBStockFirst?.reorder(html, url);
      const
        products = document.getElementById('collection-products'),
        productsSource = html.querySelector('#collection-products').innerHTML,
        pagination = document.getElementById('pagination'),
        paginationSource = html.querySelector('#pagination');

      if(products) products.insertAdjacentHTML('beforeend', productsSource);
      if(pagination && paginationSource) {
        pagination.innerHTML = paginationSource.innerHTML;
      } else {
        pagination.innerHTML = '';
      }
    })
    .finally(() => {
      pagination();
      if(theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
      if (typeof initializeVideos === 'function') initializeVideos();
      if (typeof initBgimages === 'function') initBgimages();
      if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
    })
    .catch((e) => {
      console.error(e);
    });
}

class FiltersForm extends HTMLElement {
  constructor() {
      super();
      var _this = this,
        fbtns = document.querySelectorAll(".btn-filter"),
        topFilters = document.querySelector(".filter-horizontal");

      this.secId = this.dataset.id;
      this.mql = window.matchMedia('(min-width: 767px)');
  
      fbtns.forEach((btn) =>
        btn.addEventListener('click', this.mobileFilters.bind(this))
      );
      if(topFilters && this.mql.matches === true) this.blockToggle();
      this.selectFilters();
      this.priceRangeSlider();
      this.removeFilters();
      this.selectSort();
      this.addEventListener('click', (event) => {
        if (event.target.closest('.closeFilter, [data-close-filters]')) this.closeFilters();
      });
      document.addEventListener('keydown', (event) => {
        if (!this.drawerOpen) return;
        if (event.key === 'Escape') { event.preventDefault(); this.closeFilters(); }
        if (event.key !== 'Tab') return;
        const nodes = [...this.querySelectorAll('button:not(:disabled), input:not(:disabled), select, a[href], summary')]
          .filter(node => !node.closest('[hidden]') && node.getClientRects().length);
        const first = nodes[0], last = nodes[nodes.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      document.addEventListener('click', (event) => {
        if (this.drawerOpen && !this.contains(event.target) && !event.target.closest('.btn-filter')) this.closeFilters();
      });
      window.addEventListener('popstate', () => window.location.reload());

      document.addEventListener('change', function(e){
        if (!e.target.classList.contains('optTag')) return;

        var URL = _this.dataset.url,
            paramString = new URLSearchParams(window.location.search),
            productFilters = document.querySelectorAll('input.optTag'),
            newTags = [],
            bytags = true;

        productFilters.forEach(function(el){
            if(el.value && el.checked){
                newTags.push(el.value);
            }
        });

        if (newTags.length) {
            var tags = newTags.join('+');
            _this.renderSectionFromFetch(URL + '/' + tags + '?' + paramString, bytags);
        } else {
            _this.renderSectionFromFetch(URL + '?' + paramString, bytags);
        }
      });

  }
  selectSort(){
    var shortby = document.getElementById('sort-by');
    shortby?.addEventListener('change', this.onFormSubmit.bind(this));
  }
  selectFilters(){
    var filters = this.querySelectorAll('input.dyfl, .price-range');
    filters.forEach((filter) =>
       filter.addEventListener('change', this.onFormSubmit.bind(this))
    );
  }
  priceRangeSlider(){
    const isPriceRange = document.getElementById('priceSlider');
    if(!isPriceRange) return;
    const priceSlider = document.getElementById('priceSlider'),
      min = document.getElementById('Filter-Price-GTE'),
      max = document.getElementById('Filter-Price-LTE');

    priceSlider.addEventListener('change', (evt) => {
        min.value = evt.detail.value1.toString();
        max.value = evt.detail.value2.toString();
    });
    priceSlider.addEventListener('onMouseUp', (evt) => {
      min.dispatchEvent(new Event("change"));
      max.dispatchEvent(new Event("change"));
    });
    priceSlider.addEventListener('touchend', (evt) => {
      min.dispatchEvent(new Event("change"));
      max.dispatchEvent(new Event("change"));
    });
  }
  onFormSubmit(e){
    if (e?.target.matches('[data-brand-group-toggle]')) {
      e.target.closest('[data-ob-brand-filter]').querySelectorAll('[data-brand-group-value]').forEach(input => { input.checked = e.target.checked; });
    }
    const flForm = this.querySelector('form'),
      formData = new FormData(flForm),
      params = new URLSearchParams(formData);
      this.renderSectionFromFetch(params);
  }
  renderSectionFromFetch(params = new URLSearchParams(), tags) {
    const url = tags ? `${params}&section_id=${this.secId}` : `${window.location.pathname}?section_id=${this.secId}&${params.toString()}`;
    window.OBStockFirst?.cancelInitial();
    this.fetchController?.abort();
    this.fetchController = new AbortController();
    const revision = this.fetchRevision = (this.fetchRevision || 0) + 1;
    document.body.classList.add('load-filters');
    const status = this.querySelector('[data-filter-status]');
    const done = this.querySelector('[data-close-filters]');
    if (status) status.textContent = 'Updating products…';
    if (done) done.disabled = true;
    return fetch(url, {signal: this.fetchController.signal})
      .then(response => {
        if (response.ok === false) throw new Error('Filter request failed');
        return response.text();
      })
      .then(async responseText => {
        if (revision !== this.fetchRevision) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (!html.querySelector('#collection-products')) throw new Error('Incomplete filter response');
        await window.OBStockFirst?.reorder(html, url, { signal: this.fetchController.signal });
        if (revision !== this.fetchRevision) return;
        const focusId = this.contains(document.activeElement) ? document.activeElement.id : null;
        const open = new Map([...this.querySelectorAll('.filters-item')].map(item => [item.dataset.index, item.open]));
        const scroll = this.scrollTop;
        for (const selector of ['#itemsCount', '#active-filters', '#collection-products', '.filters-item__wrapper', '#pagination', '.ob-catalog-navigation']) {
          const target = selector === '.filters-item__wrapper' ? this.querySelector(selector) : document.querySelector(selector);
          const source = html.querySelector(selector);
          if (target && source) target.innerHTML = source.innerHTML;
          else if (target && selector === '#pagination') target.innerHTML = '';
        }
        this.querySelectorAll('.filters-item').forEach(item => {
          if (open.has(item.dataset.index)) item.open = open.get(item.dataset.index);
        });
        this.scrollTop = scroll;
        if (focusId) document.getElementById(focusId)?.focus({preventScroll:true});
        const destination = tags ? params.toString() : `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
        history.pushState({page:destination}, '', destination);
        this.selectFilters(); this.priceRangeSlider(); this.removeFilters(); pagination();
        if (theme.mlcurrency) currenciesChange(document.querySelectorAll('product-card span.money'));
        if (typeof initializeVideos === 'function') initializeVideos();
        if (typeof initBgimages === 'function') initBgimages(); if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
        if (status) status.textContent = 'Products updated';
      })
      .catch(error => {
        if (revision !== this.fetchRevision || error.name === 'AbortError') return;
        if (status) status.textContent = 'Could not update products. Please change the filter again to retry.';
        console.error(error);
      })
      .finally(() => {
        if (revision !== this.fetchRevision) return;
        document.body.classList.remove('load-filters');
        if (done) done.disabled = false;
      });
  }
  removeFilters(){
    var _this = this,
        activeFl = document.querySelectorAll(".active-fl, .js-facet-remove");
    activeFl.forEach((btn) => {
        btn.addEventListener("click",(e) => {
          e.preventDefault();
          // Removing the only filter returns a URL without a query string.
          const params = new URL(btn.href, window.location.href).searchParams;
          if (btn.dataset.brandRemove) {
            const values = params.getAll('filter.p.vendor').flatMap(value => value.split(','));
            params.delete('filter.p.vendor');
            values.filter(value => value.trim().toLowerCase() !== btn.dataset.brandRemove).forEach(value => params.append('filter.p.vendor', value));
          }
          _this.renderSectionFromFetch(params);
        })
      });
  }
  mobileFilters(event) {
    this.drawerTrigger = event?.currentTarget || document.activeElement;
    this.drawerOpen = true;
    document.documentElement.classList.add('activ-filter', 'show-overly');
    this.setAttribute('role', 'dialog');
    this.setAttribute('aria-modal', 'true');
    this.setAttribute('aria-label', 'Filters');
    this.querySelector('.closeFilter')?.focus();
  }
  closeFilters() {
    this.drawerOpen = false;
    document.documentElement.classList.remove('activ-filter', 'show-overly');
    this.removeAttribute('role');
    this.removeAttribute('aria-modal');
    this.drawerTrigger?.focus();
  }
  blockToggle(){
      const body = document.body,
        filters = document.querySelectorAll(".filter-horizontal .filters-title"),
        blocks = this.querySelectorAll('.filters-item');
      filters.forEach((blk) => {
        const act = blk.closest('.filters-item[open]');
        blocks.forEach((other) => {
           if(other !== act){
             other.removeAttribute('open');
           }
        });
      });
      body.addEventListener('click', function(e){
          blocks.forEach((blk) => {
            if(e.target.closest('.filters-item[open]')) return;
             blk.removeAttribute('open');
        });
      });
  }
}
customElements.define("filters-form", FiltersForm);

document.querySelectorAll(".change-view").forEach((btn) => {
  btn.addEventListener("click",(e) => {
     e.preventDefault();
      var view = btn.dataset.view,
        href = new URL(window.location.href);
      href.searchParams.set("type", view);
      window.location = href.toString();
  });
});